import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './FatFeature.css';
import { TFatFeatureModel } from '../../types';

export function FatFeature({ text, imageUrl }: TFatFeatureModel) {
  return (
    <div className={styles['container']}>
      <div className={styles['feature']}>
        <div {...mergeStyles(styles['feature-img'], { backgroundImage: `url(${imageUrl})` })} />
        <div className={styles['text']}>
          <span>{text}</span>
        </div>
      </div>
    </div>
  );
}
